import { numberFormatAsString } from "commons/ultilities";
import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { MaterialConstants, MaterialFixDecimalConstants } from "./const";

export const Material = types
  .model({
    paperType: types.maybeNull(types.string),
    paperBrand: types.maybeNull(types.string),
    standard: types.maybeNull(types.string),
    gsmUpper: types.maybeNull(types.number),
    gsmStandard: types.maybeNull(types.number),
    gsmLower: types.maybeNull(types.number),
    thicknessUpper: types.maybeNull(types.number),
    thicknessStandard: types.maybeNull(types.number),
    thicknessLower: types.maybeNull(types.number),
    whitenessUpper: types.maybeNull(types.number),
    whitenessStandard: types.maybeNull(types.number),
    whitenessLower: types.maybeNull(types.number),
    gsmUpperFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        MaterialConstants.DEFAULT_GSM_UPPER_FACTOR_PERCENT
      )
    ),
    gsmLowerFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        MaterialConstants.DEFAULT_GSM_LOWER_FACTOR_PERCENT
      )
    ),
    thicknessUpperFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        MaterialConstants.DEFAULT_THICKNESS_UPPER_FACTOR_PERCENT
      )
    ),
    thicknessLowerFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        MaterialConstants.DEFAULT_THICKNESS_LOWER_FACTOR_PERCENT
      )
    ),
    whitenessUpperFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        MaterialConstants.DEFAULT_WHITENESS_UPPER_FACTOR_PERCENT
      )
    ),
    whitenessLowerFactorPercent: types.maybeNull(
      types.optional(
        types.number,
        MaterialConstants.DEFAULT_WHITENESS_LOWER_FACTOR_PERCENT
      )
    ),
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get gsmStandardDisplay() {
      return self.gsmStandard
        ? `${numberFormatAsString(self.gsmStandard?.toString(), {
            decimalScale: 0,
            fixedDecimalScale: true,
          })}`
        : "";
    },
    get thicknessStandardDisplay() {
      return self.thicknessStandard
        ? `${numberFormatAsString(self.thicknessStandard?.toString(), {
            decimalScale: MaterialFixDecimalConstants.THICKNESS_STANDARD,
            fixedDecimalScale: true,
          })}`
        : "";
    },
    get whitenessStandardDisplay() {
      return self.whitenessStandard
        ? `${numberFormatAsString(self.whitenessStandard?.toString(), {
            decimalScale: MaterialFixDecimalConstants.WHITENESS_STANDARD,
            fixedDecimalScale: true,
          })}`
        : "";
    },
    get gsmUpperWithFactorPercentDisplay() {
      const upperStandard = `${
        self.gsmUpperFactorPercent
          ? "+" +
            numberFormatAsString(self.gsmUpperFactorPercent.toString(), {
              decimalScale:
                MaterialFixDecimalConstants.GSM_UPPER_FACTOR_PERCENT,
              fixedDecimalScale: true,
            }) +
            "%"
          : ""
      }${
        self.gsmUpper
          ? "~" +
            numberFormatAsString(self.gsmUpper.toString(), {
              decimalScale: 1,
              fixedDecimalScale: true,
            })
          : ""
      }`;
      return upperStandard;
    },
    get gsmLowerWithFactorPercentDisplay() {
      const lowerStandard = `${
        self.gsmLowerFactorPercent
          ? "-" +
            numberFormatAsString(self.gsmLowerFactorPercent.toString(), {
              decimalScale:
                MaterialFixDecimalConstants.GSM_LOWER_FACTOR_PERCENT,
              fixedDecimalScale: true,
            }) +
            "%"
          : ""
      }${
        self.gsmLower
          ? "~" +
            numberFormatAsString(self.gsmLower.toString(), {
              decimalScale: 1,
              fixedDecimalScale: true,
            })
          : ""
      }`;
      return lowerStandard;
    },
    get thicknessUpperWithFactorPercentDisplay() {
      const upperStandard = `${
        self.thicknessUpperFactorPercent
          ? "+" +
            numberFormatAsString(self.thicknessUpperFactorPercent.toString(), {
              decimalScale:
                MaterialFixDecimalConstants.THICKNESS_UPPER_FACTOR_PERCENT,
              fixedDecimalScale: true,
            }) +
            "%"
          : ""
      }${
        self.thicknessUpper
          ? "~" +
            numberFormatAsString(self.thicknessUpper.toString(), {
              decimalScale: MaterialFixDecimalConstants.THICKNESS_UPPER,
              fixedDecimalScale: true,
            })
          : ""
      }`;
      return upperStandard;
    },
    get thicknessLowerWithFactorPercentDisplay() {
      const lowerStandard = `${
        self.thicknessLowerFactorPercent
          ? "-" +
            numberFormatAsString(self.thicknessLowerFactorPercent.toString(), {
              decimalScale:
                MaterialFixDecimalConstants.THICKNESS_LOWER_FACTOR_PERCENT,
              fixedDecimalScale: true,
            }) +
            "%"
          : ""
      }${
        self.thicknessLower
          ? "~" +
            numberFormatAsString(self.thicknessLower.toString(), {
              decimalScale: MaterialFixDecimalConstants.THICKNESS_LOWER,
              fixedDecimalScale: true,
            })
          : ""
      }`;
      return lowerStandard;
    },
    get whitenessUpperWithFactorPercentDisplay() {
      const upperStandard = `${
        self.whitenessUpperFactorPercent
          ? "+" +
            numberFormatAsString(self.whitenessUpperFactorPercent.toString(), {
              decimalScale:
                MaterialFixDecimalConstants.WHITENESS_UPPER_FACTOR_PERCENT,
              fixedDecimalScale: true,
            }) +
            "%"
          : ""
      }${
        self.whitenessUpper
          ? "~" +
            numberFormatAsString(self.whitenessUpper.toString(), {
              decimalScale: MaterialFixDecimalConstants.WHITENESS_UPPER,
              fixedDecimalScale: true,
            })
          : ""
      }`;
      return upperStandard;
    },
    get whitenessLowerWithFactorPercentDisplay() {
      const lowerStandard = `${
        self.whitenessLowerFactorPercent
          ? "-" +
            numberFormatAsString(self.whitenessLowerFactorPercent.toString(), {
              decimalScale:
                MaterialFixDecimalConstants.WHITENESS_LOWER_FACTOR_PERCENT,
              fixedDecimalScale: true,
            }) +
            "%"
          : ""
      }${
        self.whitenessLower
          ? "~" +
            numberFormatAsString(self.whitenessLower.toString(), {
              decimalScale: MaterialFixDecimalConstants.WHITENESS_LOWER,
              fixedDecimalScale: true,
            })
          : ""
      }`;
      return lowerStandard;
    },
  }));

export interface IMaterial extends Instance<typeof Material> {}
export interface IMaterialProperties extends SnapshotIn<typeof Material> {}
